import { Datagrid, FunctionField, ListProps, ReferenceField, SelectField, TextField } from 'react-admin';
import { Chip, colors } from '@material-ui/core';
import { CustomList, SortableDatagridBody } from '../../components';

export const CHOICES = [
  { id: 'PRIMARY', name: 'Destaque primário' },
  { id: 'SECUNDARY', name: 'Destaque secundário' }
]

export default function HighlightsList(props: ListProps) {
  return (
    <CustomList
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid
        body={<SortableDatagridBody filterColumn="category" />}
        rowClick="edit"
      >
        <ReferenceField
          label="Notícia"
          source="post"
          reference="posts"
          sortable={false}
        >
          <TextField source="title" />
        </ReferenceField>

        <FunctionField 
          label="Categoria" 
          sortable={false} 
          render={record => (
            <Chip
              label={CHOICES.find(i => i.id === record.category)?.name}
              style={{
                backgroundColor: record.category === 'PRIMARY' ? colors.green[500] : colors.grey[500],
                color: '#ffffff'
              }}
            />
          )} 
        />

      </Datagrid>
    </CustomList>
  );
}